import { render, staticRenderFns } from "./MiButton.vue?vue&type=template&id=76191f9c&scoped=true&"
import script from "@/components/mi/MiButton.ts?vue&type=script&lang=ts&"
export * from "@/components/mi/MiButton.ts?vue&type=script&lang=ts&"
import style0 from "@/components/mi/mi-button.scss?vue&type=style&index=0&id=76191f9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76191f9c",
  null
  
)

export default component.exports